import { OrderedEnumerable } from "../OrderedEnumerable.js";
export const orderDescending = (source, comparer) => {
    return OrderedEnumerable.generate(source, (x) => x, false, comparer);
};
